// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.main-results-container {*/
/*    width: 98%;*/
/*    margin-right: auto;*/
/*    margin-left: auto;*/
/*    display: flex;*/
/*    flex-wrap: wrap;*/
/*}*/

/*.session-container {*/
/*    background-color: rgb(248, 249, 250);*/
/*    !*border: 2px solid black;*!*/
/*    flex: 100%;*/
/*    margin-right: auto;*/
/*    margin-left: auto;*/
/*}*/

/*.qsq-container {*/
/*    display: flex;*/
/*    flex-wrap: wrap;*/
/*}*/

/*.result {*/
/*    flex: 33%;*/
/*    border: 1px solid lightgrey;*/
/*    padding: 25px;*/
/*    display: flex;*/
/*    flex-wrap: wrap;*/
/*}*/

/*.question, .answer, .error-message, .points {*/
/*    font-weight: bold;*/
/*    margin-right: auto;*/
/*    margin-left: auto;*/
/*}*/

/*.question-content, .answer-content, .error-message, .points {*/
/*    margin-right: auto;*/
/*    margin-left: auto;*/
/*}*/



.main-results-container {
    width: 98%;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    flex-wrap: wrap;
}

.session-container {
    background-color: rgb(248, 249, 250);
    /*border: 2px solid black;*/
    flex: 100% 1;
    margin-right: auto;
    margin-left: auto;
}

.qsq-container {
    display: flex;
    flex-wrap: wrap;
}

.result {
    flex: 33% 1;
    border: 1px solid lightgrey;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: left;
}

.question, .answer, .error-message, .points {
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
}

.question-content, .answer-content, .error-message, .points {
    margin-right: auto;
    margin-left: auto;
    color: #333;
    text-align: left;
}

/* Add responsiveness */
@media screen and (max-width: 768px) {
    .result {
        flex: 100% 1;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Results.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B,kBAAkB;AAClB,0BAA0B;AAC1B,yBAAyB;AACzB,qBAAqB;AACrB,uBAAuB;AACvB,IAAI;;AAEJ,uBAAuB;AACvB,4CAA4C;AAC5C,mCAAmC;AACnC,kBAAkB;AAClB,0BAA0B;AAC1B,yBAAyB;AACzB,IAAI;;AAEJ,mBAAmB;AACnB,qBAAqB;AACrB,uBAAuB;AACvB,IAAI;;AAEJ,YAAY;AACZ,iBAAiB;AACjB,mCAAmC;AACnC,qBAAqB;AACrB,qBAAqB;AACrB,uBAAuB;AACvB,IAAI;;AAEJ,gDAAgD;AAChD,yBAAyB;AACzB,0BAA0B;AAC1B,yBAAyB;AACzB,IAAI;;AAEJ,gEAAgE;AAChE,0BAA0B;AAC1B,yBAAyB;AACzB,IAAI;;;;AAIJ;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,YAAU;IACV,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI;QACI,YAAU;IACd;AACJ","sourcesContent":["/*.main-results-container {*/\n/*    width: 98%;*/\n/*    margin-right: auto;*/\n/*    margin-left: auto;*/\n/*    display: flex;*/\n/*    flex-wrap: wrap;*/\n/*}*/\n\n/*.session-container {*/\n/*    background-color: rgb(248, 249, 250);*/\n/*    !*border: 2px solid black;*!*/\n/*    flex: 100%;*/\n/*    margin-right: auto;*/\n/*    margin-left: auto;*/\n/*}*/\n\n/*.qsq-container {*/\n/*    display: flex;*/\n/*    flex-wrap: wrap;*/\n/*}*/\n\n/*.result {*/\n/*    flex: 33%;*/\n/*    border: 1px solid lightgrey;*/\n/*    padding: 25px;*/\n/*    display: flex;*/\n/*    flex-wrap: wrap;*/\n/*}*/\n\n/*.question, .answer, .error-message, .points {*/\n/*    font-weight: bold;*/\n/*    margin-right: auto;*/\n/*    margin-left: auto;*/\n/*}*/\n\n/*.question-content, .answer-content, .error-message, .points {*/\n/*    margin-right: auto;*/\n/*    margin-left: auto;*/\n/*}*/\n\n\n\n.main-results-container {\n    width: 98%;\n    margin-right: auto;\n    margin-left: auto;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.session-container {\n    background-color: rgb(248, 249, 250);\n    /*border: 2px solid black;*/\n    flex: 100%;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n.qsq-container {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.result {\n    flex: 33%;\n    border: 1px solid lightgrey;\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    text-align: left;\n}\n\n.question, .answer, .error-message, .points {\n    font-weight: bold;\n    margin-bottom: 10px;\n    text-align: left;\n}\n\n.question-content, .answer-content, .error-message, .points {\n    margin-right: auto;\n    margin-left: auto;\n    color: #333;\n    text-align: left;\n}\n\n/* Add responsiveness */\n@media screen and (max-width: 768px) {\n    .result {\n        flex: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
